module.exports = __webpack_public_path__ + "img/mc-lr-l1-b1.227138ae.gif";